import { render, staticRenderFns } from "./verify-view.vue?vue&type=template&id=52af6c30&lang=pug"
import script from "./verify-view.vue?vue&type=script&lang=js"
export * from "./verify-view.vue?vue&type=script&lang=js"
import style0 from "./verify-view.vue?vue&type=style&index=0&id=52af6c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports